/* pdp-offer: buy box behavior.
   Gallery, bundle picker, gift tracker, add to cart, dates, accordions, videos, sticky photo column, gift nudge. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- helpers ----------------------------------------------------------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function num(v) { var n = parseInt(v, 10); return isNaN(n) ? 0 : n; }

  // Money in the store's own format. Handles the five Shopify placeholders.
  // Tags in the format (some stores wrap the amount in a span) are dropped, because the script writes plain text.
  function formatMoney(cents, format) {
    var fmt = String(format || '{{amount}}').replace(/<[^>]*>/g, '');
    function digits(value, precision, thousands, decimal) {
      precision = precision === undefined ? 2 : precision;
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var n = (Math.round(value) / 100).toFixed(precision).split('.');
      return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (n[1] ? decimal + n[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, name) {
      switch (name) {
        case 'amount': return digits(cents, 2);
        case 'amount_no_decimals': return digits(cents, 0);
        case 'amount_with_comma_separator': return digits(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return digits(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return digits(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return digits(cents, 0, ' ');
        case 'amount_with_space_separator': return digits(cents, 2, ' ', ',');
        default: return digits(cents, 2);
      }
    });
  }
  function ordinal(n) {
    return n + (n === 1 ? 'st' : n === 2 ? 'nd' : n === 3 ? 'rd' : 'th');
  }

  function init(root) {
    if (root.hasAttribute('data-pdp-ready')) return;
    root.setAttribute('data-pdp-ready', '');

    var moneyFormat = root.getAttribute('data-money-format') || '{{amount}}';
    var unitOne = root.getAttribute('data-unit-one') || 'unit';
    var unitMany = root.getAttribute('data-unit-many') || 'units';
    function unit(n) { return n === 1 ? unitOne : unitMany; }
    function money(c) { return formatMoney(c, moneyFormat); }

    gallery(root);
    stickyColumn(root);
    dates(root);
    accordions(root);
    videos(root);
    var bundle = bundlePicker(root, money, unit);
    nudge(root, unit, bundle);
  }

  /* ---- gallery ------------------------------------------------------------- */
  function gallery(root) {
    var g = $('[data-fm-gallery]', root);
    if (!g) return;
    var main = $('[data-fm-main]', g);
    g.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fm-thumb]');
      if (!b || !main) return;
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = b.getAttribute('data-src');
      var alt = b.getAttribute('data-alt');
      if (alt !== null) main.alt = alt;
      $$('[data-fm-thumb]', g).forEach(function (x) {
        var on = x === b;
        x.classList.toggle('is-active', on);
        if (on) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current');
      });
    });
  }

  /* ---- sticky photo column ---------------------------------------------------
     The photo column is taller than most screens. Give it a negative top so it
     sticks by its bottom edge instead of its top, and the page can scroll on. */
  function stickyColumn(root) {
    var media = $('.fm-offer__media', root);
    if (!media) return;
    var wide = window.matchMedia('(min-width: 990px)');
    function set() {
      if (!root.isConnected) { window.removeEventListener('resize', set); return; }
      if (!wide.matches) { media.style.removeProperty('--fm-media-top'); return; }
      var top = Math.min(96, window.innerHeight - media.getBoundingClientRect().height - 24);
      media.style.setProperty('--fm-media-top', top + 'px');
    }
    set();
    window.addEventListener('resize', set);
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(media);
  }

  /* ---- dates ------------------------------------------------------------------ */
  function dates(root) {
    var locale = root.getAttribute('data-locale') || 'en';
    var ship = $('[data-fm-ship5-date]', root);
    if (ship) {
      var days = num(root.getAttribute('data-delivery-days')) || 4;
      var d = new Date(), added = 0;
      while (added < days) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) added++; }
      try { ship.textContent = d.toLocaleDateString(locale, { weekday: 'short', month: 'short', day: 'numeric' }); } catch (e) {}
    }
    var stock = $('[data-fm-stock-date]', root);
    if (stock && root.getAttribute('data-stock-mode') !== 'fixed') {
      try {
        var n = new Date();
        var t = new Date(n.getFullYear(), n.getMonth() + 2, 1);
        // English reads "December 1st 2026". Other languages get their own long date.
        stock.textContent = /^en/i.test(locale)
          ? t.toLocaleDateString(locale, { month: 'long' }) + ' ' + ordinal(1) + ' ' + t.getFullYear()
          : t.toLocaleDateString(locale, { month: 'long', day: 'numeric', year: 'numeric' });
      } catch (e) {}
    }
  }

  /* ---- accordions -------------------------------------------------------------
     Native details. Clicking empty space inside an open body closes it. */
  function accordions(root) {
    var wrap = $('[data-fm-acc]', root);
    if (!wrap) return;
    var down = null;
    wrap.addEventListener('pointerdown', function (e) { down = { x: e.clientX, y: e.clientY, t: Date.now() }; }, true);
    wrap.addEventListener('click', function (e) {
      var d = e.target.closest('details');
      if (!d || !d.open) return;
      if (e.target.closest('summary')) return;
      if (e.target.closest('video, a, button, input, select, textarea, label, iframe, .fm-yt, .fm-yt__meta')) return;
      var sel = window.getSelection && window.getSelection();
      if (sel && String(sel).length) return;
      if (!down || Math.abs(e.clientX - down.x) > 6 || Math.abs(e.clientY - down.y) > 6 || Date.now() - down.t > 600) return;
      d.open = false;
      var s = $('summary', d);
      if (s) s.focus({ preventScroll: true });
    });
  }

  /* ---- videos ------------------------------------------------------------------
     Start paused. Play with sound on click, pause on a second click. */
  function videos(root) {
    function allVideos() { return $$('.fm-ugc-strip video, .fm-yt video', root); }
    function pauseOthers(except) {
      allVideos().forEach(function (v) { if (v !== except && !v.paused) v.pause(); });
    }
    function bind(wrap, video, playBtn, soundBtn) {
      if (!video) return;
      var strip = wrap.hasAttribute('data-fm-strip-card');
      function label(playing) { if (playBtn) playBtn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video'); }
      function start() {
        pauseOthers(video);
        video.muted = false;
        wrap.classList.remove('is-muted');
        wrap.classList.add('is-playing');
        label(true);
        var p = video.play();
        if (p && p.catch) p.catch(function () { wrap.classList.remove('is-playing'); label(false); });
      }
      function stop() { video.pause(); wrap.classList.remove('is-playing'); label(false); }
      function toggle() { if (video.paused) start(); else stop(); }
      // The play button toggles too, so a video started from the keyboard can be stopped from the keyboard.
      if (strip) {
        wrap.addEventListener('click', toggle);
      } else {
        if (playBtn) playBtn.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
        video.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
      }
      video.addEventListener('pause', function () { wrap.classList.remove('is-playing'); label(false); });
      video.addEventListener('ended', function () { wrap.classList.remove('is-playing'); label(false); });
      if (soundBtn) soundBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        wrap.classList.toggle('is-muted', video.muted);
      });
    }
    $$('[data-fm-strip-card]', root).forEach(function (card) {
      bind(card, $('video', card), $('.fm-ugc-strip__play', card), null);
    });
    $$('[data-fm-selfvid]', root).forEach(function (card) {
      bind(card, $('video', card), $('.fm-yt__playbtn', card), $('.fm-yt__sound', card));
    });
  }

  /* ---- bundle picker, gift tracker and add to cart -------------------------------- */
  function bundlePicker(root, money, unit) {
    var bp = $('[data-fm-bp]', root);
    if (!bp) return null;
    var rows = $$('[data-fm-bp-bar]', bp);
    var fam = $('[data-fm-bp-qty]', bp);
    var form = $('form.form', root);
    var qtyInput = $('[data-fm-qty-input]', root);
    var btn = $('[data-fm-atc]', root);
    var btnLabel = $('[data-fm-atc-label]', root);
    var errEl = $('[data-fm-atc-error]', root);
    var tracker = $('[data-fmgr]', root);
    var errorText = root.getAttribute('data-error-text') || '';
    var soldOutText = root.getAttribute('data-sold-out-text') || '';
    var addedText = root.getAttribute('data-added-text') || '';
    function isAvail(v) { return v !== 'false'; }

    // Row 3 data: variant 3 for exactly three, variant 4 priced per unit for more.
    var famData = fam ? {
      v3: fam.getAttribute('data-v3'), p3: num(fam.getAttribute('data-p3')), c3: num(fam.getAttribute('data-c3')), a3: isAvail(fam.getAttribute('data-a3')),
      v4: fam.getAttribute('data-v4'), p4: num(fam.getAttribute('data-p4')), c4: num(fam.getAttribute('data-c4')), a4: isAvail(fam.getAttribute('data-a4')),
      max: num(fam.getAttribute('data-max')) || 3
    } : null;
    var slider = fam ? $('[data-fm-qty-slider]', fam) : null;
    var hasStep = !!(famData && famData.v4 && slider);
    var marks = hasStep ? $$('.fm-bp__mark', fam) : [];
    var thumbLbl = hasStep ? $('.fm-bp__thumb-lbl', fam) : null;
    var hintEl = hasStep ? $('[data-fm-hint]', fam) : null;

    var state = { row: num(bp.getAttribute('data-default')) || 2, n: 3 };
    var firstFamPick = true;

    function rowEl(r) { return rows.filter(function (x) { return num(x.getAttribute('data-qty')) === r; })[0]; }

    // What is selected right now: variant id, cart quantity, prices and the quantity that counts for gifts.
    function current() {
      if (state.row === 3 && famData) {
        if (hasStep && state.n >= 4) {
          return { id: famData.v4, qty: state.n, price: state.n * famData.p4, compare: state.n * famData.c4, count: state.n, avail: famData.a4 };
        }
        return { id: famData.v3, qty: 1, price: famData.p3, compare: famData.c3, count: 3, avail: famData.a3 };
      }
      var el = rowEl(state.row) || rowEl(2) || rows[0];
      var input = $('input', el);
      return { id: input.value, qty: 1, price: num(input.getAttribute('data-price')), compare: num(input.getAttribute('data-compare')), count: num(el.getAttribute('data-qty')), avail: isAvail(input.getAttribute('data-available')) };
    }

    function perUnit(price, count) { return Math.round(price / count); }

    function render() {
      var cur = current();
      state.cur = cur;

      // Row highlight and radios
      rows.forEach(function (el) {
        var r = num(el.getAttribute('data-qty'));
        var on = r === state.row;
        var input = $('input', el);
        if (input) input.checked = on;
        if (el === fam) el.classList.toggle('is-on', on); else el.classList.toggle('is-sel', on);
      });
      bp.classList.toggle('is-qty', state.row === 3);

      // Row 3 numbers. Closed, it shows the base three. Open, it shows what the stepper says.
      if (fam && famData) {
        var fcur = state.row === 3 ? cur : { price: famData.p3, compare: famData.c3, count: 3, id: famData.v3 };
        var radio = $('.fm-bp__radio', fam);
        if (radio) { radio.value = fcur.id; radio.setAttribute('data-price', fcur.price); radio.setAttribute('data-compare', fcur.compare); }
        var p = $('[data-fm-qty-price]', fam), c = $('[data-fm-qty-compare]', fam), sv = $('[data-fm-qty-save]', fam), per = $('[data-fm-qty-per]', fam), cnt = $('[data-fm-qty-cnt]', fam);
        if (p) p.textContent = money(fcur.price);
        var save = fcur.compare - fcur.price;
        if (c) { c.textContent = money(fcur.compare); c.hidden = !(save > 0); }
        if (sv) {
          sv.hidden = !(save > 0);
          sv.textContent = (sv.getAttribute('data-label') || '') + ' ' + money(save);
        }
        if (per) {
          per.textContent = money(perUnit(fcur.price, fcur.count)) + (per.getAttribute('data-tpl') || '');
        }
        if (cnt) { var was = cnt.textContent; cnt.textContent = '×' + fcur.count; if (was !== cnt.textContent && !reduceMotion) { cnt.classList.add('is-bump'); setTimeout(function () { cnt.classList.remove('is-bump'); }, 160); } }
        if (hasStep) {
          var nEl = $('[data-fm-qty-n]', fam);
          slider.value = state.n;
          if (nEl) nEl.textContent = state.n + ' ' + unit(state.n);
          $('[data-fm-qty-plus]', fam).disabled = state.n >= famData.max;
          placeStepper();
        }
      }

      // Form fields
      if (qtyInput) qtyInput.value = cur.qty;

      // Button price pill
      var ap = $('[data-fm-atc-p]', root), ac = $('[data-fm-atc-c]', root);
      if (ap) ap.textContent = money(cur.price);
      if (ac) { ac.textContent = money(cur.compare); ac.hidden = !(cur.compare > cur.price); }

      syncButton();
      updateGifts(cur.count);
      fitButton();
    }

    /* The slider fill, the gift markers on the track and the quantity label under the thumb are placed
       from the real slider width, so they follow the layout at any screen size. */
    function placeStepper() {
      if (!hasStep || !slider.offsetWidth) return;
      var th = 24, mn = 3, mx = famData.max, range = Math.max(1, mx - mn), span = slider.offsetWidth - th;
      var f = Math.max(0, Math.min(1, (state.n - mn) / range));
      slider.style.setProperty('--fmp', Math.round(th / 2 + f * span) + 'px');
      marks.forEach(function (m) {
        var need = num(m.getAttribute('data-min'));
        var left = Math.round(slider.offsetLeft + th / 2 + ((need - mn) / range) * span) + 'px';
        if (m.style.left !== left) m.style.left = left;
        var on = state.n >= need;
        if (on && !m.classList.contains('is-on') && !reduceMotion) {
          m.classList.add('is-pop');
          setTimeout(function () { m.classList.remove('is-pop'); }, 500);
        }
        m.classList.toggle('is-on', on);
        m.classList.toggle('is-here', state.n === need);
      });
      if (thumbLbl) {
        thumbLbl.textContent = state.n + ' ' + unit(state.n);
        thumbLbl.style.left = Math.round(slider.offsetLeft + th / 2 + f * span) + 'px';
        thumbLbl.style.top = Math.round(slider.offsetTop + slider.offsetHeight / 2) + 'px';
      }
    }
    if (hasStep) {
      window.addEventListener('resize', placeStepper);
      if ('ResizeObserver' in window) new ResizeObserver(placeStepper).observe(slider);
    }

    /* One time hint bar under the slider, shown the first time row 3 opens. */
    var hintTimer = null, hintOff = null;
    function showHint() {
      if (!hintEl) return;
      hintEl.hidden = false;
      fam.classList.add('is-hint');
      setTimeout(function () { hintEl.classList.add('is-on'); }, 30);
      hintTimer = setTimeout(hideHint, 10000);
    }
    function hideHint() {
      if (!hintEl) return;
      clearTimeout(hintTimer);
      hintEl.classList.remove('is-on');
      fam.classList.remove('is-hint');
      clearTimeout(hintOff);
      hintOff = setTimeout(function () { hintEl.hidden = true; }, 300);
    }
    var hintX = hintEl ? $('[data-fm-hint-x]', hintEl) : null;
    if (hintX) hintX.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); hideHint(); });
    if (hintEl) hintEl.addEventListener('click', function (e) { e.stopPropagation(); });

    /* Gift tracker */
    var giftsUnlocked = 0;
    function updateGifts(count) {
      var cards = tracker ? $$('[data-fmgr-card]', tracker) : [];
      var unlocked = 0, nextNeed = Infinity, nextName = '', shipNeed = Infinity, shipName = '';
      var lockedLabel = tracker ? tracker.getAttribute('data-locked-label') : '';
      cards.forEach(function (card) {
        var need = num(card.getAttribute('data-unlock'));
        var on = need <= count;
        var was = card.classList.contains('is-on');
        card.classList.toggle('is-on', on);
        var nameEl = $('.fmgr__name', card);
        if (nameEl) nameEl.textContent = on ? card.getAttribute('data-name') : lockedLabel;
        if (on) unlocked++;
        else if (card.hasAttribute('data-ship')) { if (need < shipNeed) { shipNeed = need; shipName = card.getAttribute('data-name'); } }
        else if (need < nextNeed) { nextNeed = need; nextName = card.getAttribute('data-name'); }
        if (was !== on && !reduceMotion && card.__ready) {
          card.classList.remove('is-nudge'); void card.offsetWidth; card.classList.add('is-nudge');
          setTimeout(function () { card.classList.remove('is-nudge'); }, 750);
        }
        card.__ready = true;
        var unlockEl = $('.fmgr__unlock', card);
        if (unlockEl) unlockEl.textContent = tracker.getAttribute('data-unlock-prefix') + ' ' + need + ' ' + unit(need);
      });
      // A shipping perk is only named when no other gift is left to unlock.
      if (!isFinite(nextNeed)) { nextNeed = shipNeed; nextName = shipName; }
      giftsUnlocked = unlocked;
      if (tracker) {
        var countEl = $('[data-fmgr-count]', tracker);
        if (countEl) countEl.textContent = (tracker.getAttribute('data-count-label') || '').replace('{n}', unlocked).replace('{t}', cards.length);
        var msg = $('[data-fmgr-msg]', tracker);
        if (msg) {
          msg.textContent = '';
          if (isFinite(nextNeed)) {
            var more = nextNeed - count;
            var icon = tracker.getAttribute('data-msg-icon');
            if (icon) msg.appendChild(document.createTextNode(icon + ' '));
            msg.appendChild(document.createTextNode(tracker.getAttribute('data-msg-add') + ' '));
            var b1 = document.createElement('b');
            b1.textContent = more + ' ' + tracker.getAttribute('data-msg-more') + ' ' + unit(more);
            msg.appendChild(b1);
            msg.appendChild(document.createTextNode(' ' + tracker.getAttribute('data-msg-to') + ' '));
            var b2 = document.createElement('b');
            b2.textContent = nextName;
            msg.appendChild(b2);
          } else {
            var doneIcon = tracker.getAttribute('data-done-icon'), doneLead = tracker.getAttribute('data-done-lead');
            if (doneIcon) msg.appendChild(document.createTextNode(doneIcon + ' '));
            if (doneLead) {
              var b3 = document.createElement('b');
              b3.textContent = doneLead;
              msg.appendChild(b3);
              msg.appendChild(document.createTextNode(' '));
            }
            msg.appendChild(document.createTextNode(tracker.getAttribute('data-msg-done') || ''));
          }
        }
        var pill = $('[data-fm-atc-gifts]', root);
        if (pill) {
          pill.hidden = unlocked === 0;
          var l = $('.fm-atc-gifts__l', pill), s = $('.fm-atc-gifts__s', pill);
          if (l) l.textContent = (tracker.getAttribute('data-atc-long') || '').replace('{n}', unlocked);
          if (s) s.textContent = (tracker.getAttribute('data-atc-short') || '').replace('{n}', unlocked);
        }
      }
    }

    /* Keep the button on one line: drop the compare price and the long gifts text when it is too wide. */
    function fitButton() {
      if (!btn) return;
      var label = $('.main-atc__label', btn);
      if (!label) return;
      // The price pill does not shrink while the gifts pill exists, so a label that is too wide really overflows.
      function over() { return label.scrollWidth > label.clientWidth + 1; }
      btn.classList.remove('is-tight', 'is-tighter');
      if (!over()) return;
      btn.classList.add('is-tight');
      if (over()) btn.classList.add('is-tighter');
    }
    if ('ResizeObserver' in window && btn) new ResizeObserver(function () { fitButton(); }).observe(btn);

    /* Selecting rows */
    function select(r, opts) {
      opts = opts || {};
      if (!rowEl(r)) return;
      state.row = r;
      // Row 3 starts at three each time it is opened. A closed row 3 always shows its base numbers.
      if (r === 3) { if (opts.n) state.n = Math.max(3, Math.min(famData ? famData.max : 3, opts.n)); }
      else state.n = 3;
      if (r === 3 && firstFamPick && hasStep && !opts.silent) {
        firstFamPick = false;
        showHint();
      }
      render();
    }
    rows.forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (e.target.closest('.fm-bp__qty-step')) return;
        // A label forwards its click to the radio. Handle the change from the radio instead.
        if (el !== fam) return;
        if (state.row !== 3) select(3);
      });
      var input = $('input', el);
      if (input) input.addEventListener('change', function () { if (input.checked) select(num(el.getAttribute('data-qty'))); });
    });

    if (hasStep) {
      var minusBtn = $('[data-fm-qty-minus]', fam), plusBtn = $('[data-fm-qty-plus]', fam);
      var step = function (delta) { state.n = Math.max(3, Math.min(famData.max, state.n + delta)); render(); };
      plusBtn.addEventListener('click', function (e) { e.stopPropagation(); step(1); });
      // At three, minus steps back down to the row below.
      minusBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (state.n > 3) { step(-1); return; }
        var below = rowEl(2) ? 2 : 1;
        select(below);
        var input = $('input', rowEl(below));
        if (input) input.focus({ preventScroll: true });
      });
      slider.addEventListener('input', function () { state.n = num(slider.value) || 3; render(); });
      slider.addEventListener('click', function (e) { e.stopPropagation(); });
      $('.fm-bp__qty-step', fam).addEventListener('click', function (e) { e.stopPropagation(); });
    }

    // A gift tile that is still locked selects the row that unlocks it.
    if (tracker) tracker.addEventListener('click', function (e) {
      var card = e.target.closest('[data-fmgr-card]');
      if (!card || card.classList.contains('is-on')) return;
      var need = num(card.getAttribute('data-unlock'));
      selectForCount(need);
    });

    // Pick the row that reaches a quantity: row 1 or 2 when they are enough, otherwise row 3 at that number.
    function selectForCount(n) {
      if (n <= 1) select(1);
      else if (n === 2 && rowEl(2)) select(2);
      else if (famData) select(3, { n: n });
      else select(rowEl(2) ? 2 : 1);
    }

    /* Add to cart */
    var busy = false, flashing = false;
    // The button follows the busy state and the stock of the chosen variant.
    function syncButton() {
      if (!btn) return;
      var out = !!(state.cur && state.cur.avail === false);
      btn.disabled = busy || out;
      btn.classList.toggle('is-soldout', out);
      if (btnLabel && !flashing) {
        var text = out ? soldOutText : (btnLabel.getAttribute('data-label') || '');
        if (btnLabel.textContent !== text) btnLabel.textContent = text;
      }
    }
    function setBusy(on) {
      busy = on;
      if (btn) { btn.classList.toggle('is-busy', on); btn.setAttribute('aria-busy', on ? 'true' : 'false'); }
      syncButton();
    }
    // The Back button can restore the page from memory with the button still busy.
    window.addEventListener('pageshow', function (e) { if (e.persisted) setBusy(false); });
    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg || '';
      errEl.hidden = !msg;
    }
    // When the shopper stays on the page, the label says so for a moment.
    function flashAdded() {
      if (!btnLabel || !addedText) return;
      flashing = true;
      btnLabel.textContent = addedText;
      fitButton();
      setTimeout(function () { flashing = false; syncButton(); fitButton(); }, 1800);
    }
    if (form) form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // the plain form post still works
      e.preventDefault();
      if (busy) return;
      if (state.cur && state.cur.avail === false) return;
      showError('');
      var cur = current();
      var items = [{ id: Number(cur.id), quantity: cur.qty }];
      if (tracker) $$('[data-fmgr-card].is-on[data-variant]', tracker).forEach(function (card) {
        var v = Number(card.getAttribute('data-variant'));
        if (v && v !== items[0].id) items.push({ id: v, quantity: 1 });
      });
      setBusy(true);
      fetch(root.getAttribute('data-add-url') || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        return res.json().then(function (json) { return { ok: res.ok, json: json }; }, function () { return { ok: res.ok, json: {} }; });
      }).then(function (r) {
        if (!r.ok) {
          setBusy(false);
          showError(r.json && (r.json.description || r.json.message) || errorText);
          return;
        }
        var mode = root.getAttribute('data-after-add');
        if (mode === 'checkout') { window.location.href = '/checkout'; return; }
        if (mode === 'cart') { window.location.href = root.getAttribute('data-cart-url') || '/cart'; return; }
        setBusy(false);
        flashAdded();
        document.dispatchEvent(new CustomEvent('pdp:added', { detail: { items: items, response: r.json } }));
      }).catch(function () {
        setBusy(false);
        showError(errorText);
      });
    });

    render();
    return { select: select, selectForCount: selectForCount, current: current, count: function () { return state.cur ? state.cur.count : 0; }, gifts: function () { return tracker ? $$('[data-fmgr-card]', tracker) : []; } };
  }

  /* ---- gift nudge --------------------------------------------------------------------
     A few seconds after load a small bar slides up and offers the quantity that unlocks the next gift. */
  function nudge(root, unit, bundle) {
    if (root.getAttribute('data-nudge') !== 'true' || !bundle) return;
    var textTpl = root.getAttribute('data-nudge-text') || '';
    var btnTpl = root.getAttribute('data-nudge-button') || '';
    setTimeout(function () {
      if (!root.isConnected) return;
      var count = bundle.count();
      var next = Infinity;
      bundle.gifts().forEach(function (card) {
        var need = num(card.getAttribute('data-unlock'));
        if (need > count && need < next) next = need;
      });
      if (!isFinite(next)) return;
      var more = next - count;
      var el = document.createElement('div');
      el.className = 'fm-npop';
      el.setAttribute('role', 'status');
      var close = document.createElement('button');
      close.type = 'button'; close.className = 'fm-npop__x'; close.setAttribute('aria-label', 'Close'); close.textContent = '×';
      var t = document.createElement('div');
      t.className = 'fm-npop__t';
      // Bold the number part of the text.
      var filled = textTpl.replace('{unit}', unit(more));
      var parts = filled.split('{n}');
      parts.forEach(function (part, i) {
        t.appendChild(document.createTextNode(part));
        if (i < parts.length - 1) { var b = document.createElement('b'); b.textContent = more; t.appendChild(b); }
      });
      var go = document.createElement('button');
      go.type = 'button'; go.className = 'fm-npop__go'; go.textContent = btnTpl.replace('{n}', more).replace('{unit}', unit(more));
      el.appendChild(close); el.appendChild(t); el.appendChild(go);
      root.appendChild(el);
      var auto;
      function hide() {
        clearTimeout(auto);
        el.classList.remove('is-on');
        setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 320);
      }
      close.addEventListener('click', hide);
      go.addEventListener('click', function () {
        hide();
        bundle.selectForCount(next);
        var bp = $('[data-fm-bp]', root);
        if (bp) bp.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      });
      setTimeout(function () { el.classList.add('is-on'); }, 30);
      auto = setTimeout(hide, 5000);
    }, 3000);
  }

  function boot() { $$('[data-pdp-offer]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
